<script>
import ListViewTemplate from './ListViewTemplate'

import Vue from 'vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

import feedbackMixin from '../mixins/feedback'
import listViewMixin from '../mixins/list-view'
import exportFileMixin from "../mixins/export-file";

Vue.use(VueAxios, axios);

export default {
	name: 'Companies',
	mixins: [feedbackMixin, listViewMixin, exportFileMixin],
	extends: ListViewTemplate,
	data() {
		return {
			primaryKey: "Company_PK_ID",
			columns: [
				{
					name: "Company_PK_ID",
					displayName: "ID",
					sort: 0,
				},
				{
					name: "Company Name",
					displayName: "Name",
					sort: 0
				},
				{
					name: "Address 1",
					displayName: "Address 1",
					sort: 0
				},
				{
					name: "Address 2",
					displayName: "Address 2",
					sort: 0
				},
				{
					name: "City",
					displayName: "City",
					sort: 0
				},
				{
					name: "State",
					displayName: "State",
					sort: 0
				},
				{
					name: "Date Created",
					displayName: "Created",
					sort: 0
				},
				{
					name: "Created By",
					displayName: "By",
					searchName: "Created By",
					sort: 0
				},
				{
					name: "Date Modified",
					displayName: "Modified",
					sort: 0
				},
				{
					name: "Modified By",
					displayName: "By",
					searchName: "Created By",
					sort: 0
				}
			],
			fields: [
				{
					key: "Company_PK_ID",
					label: "ID",
					sortable: true,
					stickyColumn: true
				},
				{
					key: "Company Name",
					label: "Name",
					sortable: true
				},
				{
					key: "Address 1",
					label: "Address 1",
					sortable: true
				},
				{
					key: "Address 2",
					label: "Address 2",
					sortable: true
				},
				{
					key: "City",
					label: "City",
					sortable: true
				},
				{
					key: "State",
					label: "State",
					sortable: true
				},
				{
					key: "Date Created",
					label: "Created",
					sortable: true
				},
				{
					key: "Created By",
					label: "By",
					searchName: "Created By",
					sortable: true
				},
				{
					key: "Date Modified",
					label: "Modified",
					sortable: true
				},
				{
					key: "Modified By",
					label: "By",
					searchName: "Created By",
					sortable: true
				}
			],
			headerTitle: 'Companies',
			restEntity: 'companies',
			restDetailEntity: 'company',
			leftmostColumn: 'cell(Company_PK_ID)'
		}
	}
}
</script>
<style scoped>

</style>